import api from "./api";

export function login(id, password) {
  let endpoint = process.env.REACT_APP_DATA_MANAGER_ENDPOINT

  return api.post(endpoint + '/login',
    null,
    {
      params: {
        id: id,
        password: password,
      }
    }
  )
}

export function signup(id, password, verifyCode) {
  let endpoint = process.env.REACT_APP_DATA_MANAGER_ENDPOINT

  return api.post(endpoint + '/signup',
    null,
    {
      params: {
        id: id,
        password: password,
        verifyCode: verifyCode
      }
    }
  )
}
